import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import house from './config/house';
import government from './config/government';
import store from '@/store'

const i18n = new VueI18n({
    locale: store.state.locale,
    messages: {
        house,
        government
    }
})

export default i18n
